import HiggsPromise from '../../utils/higgsPromise';
let commonUrl = '/finance/portrait/basicinfo/';

/* ------------------------ 财务画像-基本信息 ------------------------ */
/* 公司基本信息
*/
export function companyBeseInfo(data) {
    return HiggsPromise({
        url: commonUrl + 'companyinfo',
        data: data
    });
}

/* 工商变更
*/
export function businessChange(data) {
    return HiggsPromise({
        url: commonUrl + 'bgxxinfo',
        data: data
    });
}

/* ------------------------ 财务画像-基本信息-股权信息 ------------------------ */
/* 子公司构成
*/
export function subsidiaryForm(data) {
    return HiggsPromise({
        url: commonUrl + 'companyfzjg',
        data: data
    });
}

/* 实际控制人及变更情况
*/
export function ActualControllerApi(data) {
    return HiggsPromise({
        url: commonUrl + 'stockaccontroller',
        data: data
    });
}

// 公司近年分红情况
export function companyDividendApi(data) {
    return HiggsPromise({
        url: commonUrl + 'stocksharebonus',
        data: data
    });
}

// 股东减持情况
export function reduceShareholderApi(data) {
    return HiggsPromise({
        url: commonUrl + 'stockshareholderreduce',
        data: data
    });
}

// 前十大股东持股信息
export function topTenShareholderApi(data) {
    return HiggsPromise({
        url: commonUrl + 'stocktop10shareholder',
        data: data
    });
}

/* ------------------------ 财务画像-基本信息-财务总览 ------------------------ */
/* 年报审计意见
*/
export function reportOption(data) {
    return HiggsPromise({
        url: commonUrl + 'reportaudit',
        data: data
    });
}

/* 公司财务摘要
*/
export function fiancialsummary(data) {
    return HiggsPromise({
        url: commonUrl + 'fiancialsummary',
        data: data
    });
}

/* 公司年报
*/
export function companyYearReport(data) {
    return HiggsPromise({
        url: commonUrl + 'reportannounce',
        data: data
    });
}

/* 行业公司地理分布-地图
*/
export function companyIndustrygeo(data) {
    return HiggsPromise({
        url: commonUrl + 'industrygeo',
        data: data
    });
}

/* 行业公司地理分布-总资产-总利润
*/
export function assetIndustrygeo(data) {
    return HiggsPromise({
        url: commonUrl + 'industrydevelopment',
        data: data
    });
}

/* 行业公司地理分布-财务摘要
*/
export function financialAbstract(data) {
    return HiggsPromise({
        url: commonUrl + 'industrycompanyflist',
        data: data
    });
}

/* 行业公司地理分布-财务摘要详情
*/
export function financialInfo(data) {
    return HiggsPromise({
        url: commonUrl + 'industryfdetail',
        data: data
    });
}

/* 同类公司趋势对比
*/
export function sameCompanyContrast(data) {
    return HiggsPromise({
        url: commonUrl + 'industryftrend',
        data: data
    });
}

/* 资产负债构成
*/
export function assetLiabilit(data) {
    return HiggsPromise({
        url: commonUrl + 'companybalanceconsist',
        data: data
    });
}

/* 主营业务变动
*/
export function business(data) {
    return HiggsPromise({
        url: commonUrl + 'businessportion',
        data: data
    });
}

/* 关键财务指标趋势对比
*/
export function fiancialtrend(data) {
    return HiggsPromise({
        url: commonUrl + 'fiancialtrend',
        data: data
    });
}

/* 重要指标变动原因
*/
export function importantChange(data) {
    return HiggsPromise({
        url: commonUrl + 'indexchange',
        data: data
    });
}

/* 公司应收应付款项账龄情况
*/
export function reportNormal(data) {
    return HiggsPromise({
        url: commonUrl + 'getReportAbnormal',
        data: data
    });
}

/* ------------------------ 财务画像-基本信息-人员信息 ------------------------ */
/* 高管学历情况
*/
export function getEducation(data) {
    return HiggsPromise({
        url: commonUrl + 'getEmployComposite',
        data: data
    });
}

/* 高管薪酬
*/
export function executivesWage(data) {
    return HiggsPromise({
        url: commonUrl + 'getExecutSalary',
        data: data
    });
}

/* ------------------------ 财务画像-基本信息-研发及产权信息 ------------------------ */
/* 研发人员及投入
*/
export function reaserchInput(data) {
    return HiggsPromise({
        url: commonUrl + 'researchtrend',
        data: data
    });
}

/* 研发结果
*/
export function reaserchResult(data) {
    return HiggsPromise({
        url: commonUrl + 'patentInfo',
        data: data
    });
}

/* 专利数量
*/
export function reaserchNum(data) {
    return HiggsPromise({
        url: commonUrl + 'patentCountTrend',
        data: data
    });
}

/* 商标
*/
export function trademark(data) {
    return HiggsPromise({
        url: commonUrl + 'trademarkInfo',
        data: data
    });
}

/* 软件著作
*/
export function software(data) {
    return HiggsPromise({
        url: commonUrl + 'softwCopyrInfo',
        data: data
    });
}

/* 做品著作
*/
export function production(data) {
    return HiggsPromise({
        url: commonUrl + 'copyrightsInfo',
        data: data
    });
}

/* 招聘人数时间分布
*/
export function recruitment(data) {
    return HiggsPromise({
        url: commonUrl + 'getRecruitInfo',
        data: data
    });
}


// WEBPACK FOOTER //
// ./src/services/financialPicture/baseInfo.js